import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../providers/auth.service';
import { PublicRecordsService } from '../../providers/public-records.service';
import { PayeeService } from '../../providers/payee.service';
import { SignatureService } from '../../providers/signature.service';
import { HorseShowEntryService } from '../../providers/horse-show-entry.service';
import { SmsApiSessionService } from '../../providers/sms-api-session.service';
import { PersonService } from '../../providers/person.service';
import { AddPersonViewService } from '../people/providers/add-person-view.service'
import { Horse_show } from '../../models/horse_show';
import { Horse_show_entry } from '../../models/horse_show_entry';
import { Payee } from '../../models/payee';
import { Signature } from '../../models/signature';
import { Person } from '../../models/person';
import { User } from '../../models/user';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { faExchange, faPlus, faUser, faSave }  from '@fortawesome/fontawesome-pro-regular';
import { ModalLoginComponent } from '../modal-login/modal-login.component';
import { ModalChoosePersonComponent } from '../people/modal-choose-person/modal-choose-person.component';
import { ModalAddPersonComponent } from '../people/modal-add-person/modal-add-person.component';
import { ModalChoosePayeeComponent } from '../people/modal-choose-payee/modal-choose-payee.component';
import _ from 'lodash';

@Component({
  standalone: false,
  selector: 'app-edit-payee-for-horse-show',
  templateUrl: './edit-payee-for-horse-show.component.html',
styleUrls:  ['./edit-payee-for-horse-show.component.css']
})
export class EditPayeeForHorseShowComponent extends SmsAbstractAppPage implements OnInit {

	horse_show_id: string;
	entry_id: string;
	payee_id: string;
	//The user's other entries on this W9 that get the corrected W9 too (PayeeOtherEntriesComponent)
	other_entry_ids: string[] = [];
	//This entry was updated but some of the other entries were not - the reasons are shown
	moves_incomplete: boolean = false;
	logged_in: boolean = false;
	horse_show_entry: Horse_show_entry = new Horse_show_entry({});
	horse_show: Horse_show = new Horse_show({});
	payee: Payee = new Payee({});
  originalPayee: Payee = new Payee({});

	signature: Signature = new Signature({});
	signer_person: Person = new Person({});
	has_usef_contact_override: boolean;
	submitted: boolean = false;

	saved$: EventEmitter<boolean> = new EventEmitter<boolean>();

	faExchange = faExchange;
	faPlus = faPlus;
	faUser = faUser;
	faSave = faSave;

  constructor(private authService: AuthService,
  	private publicRecordsService: PublicRecordsService,
  	private payeeService: PayeeService,
  	private signatureService: SignatureService,
  	private horseShowEntryService: HorseShowEntryService,
  	private personService: PersonService,
  	private router: Router,
  	private route: ActivatedRoute,
  	private smsApiSessionService: SmsApiSessionService,
  	private addPersonViewService: AddPersonViewService,
  	private modal: NgbModal) {
  	super();
   }

  ngOnInit() {
  	this.authService.logout().then(result => {

  		this.route.params.subscribe(params => {

  			let errors: string[] = [];

          if(params['horse_show_id']){
          	this.horse_show_id = params['horse_show_id'];
          } else {
          	errors.push("Horse show ID is required for this form.");
          }

		 if(params['entry_id']){
          	this.entry_id = params['entry_id'];
          } else {
          	errors.push("Entry ID is required for this form.");
          }

          if(params['payee_id']){
          	this.payee_id = params['payee_id'];
          } else {
          	this.handleMessage("warning", "No ID for a current payee W9 was submitted with this request. Please use this form to create a new W9 and attach it to this entry.");
          }

          if(errors.length == 0){

          	this.publicRecordsService.getHorseShow(this.horse_show_id).then(horse_show => {
          		this.horse_show = horse_show;
          		this.publicRecordsService.getHorseShowEntry(this.entry_id).then(horse_show_entry => {
          			this.horse_show_entry = horse_show_entry;
          			this.handleLogin();
          		}).catch(error =>{
          			this.handleError(error);
          		});
          	}).catch(error => {
          		this.handleError(error);
          	});

          } else {

          	this.handleError(errors.join("\n"));

          }

      });

      }).catch(error => {
        this.handleError(error);
      });
  }

  handleLogin() {

  	    let modal_ref_login = this.modal.open(ModalLoginComponent, { size: 'lg'});
         modal_ref_login.componentInstance.message = "Log in to your Show Management System account to update the W9 details for your payee"
         modal_ref_login.componentInstance.username = this.horse_show_entry.user_name;
         modal_ref_login.componentInstance.logged_in$.subscribe(is_logged_in => {
         	if(!is_logged_in){
         	  return;
         	}
         	this.logged_in = true;
         	modal_ref_login.close();
           this.initBlankSignature();
           this.getDefaultUserPerson();
           if(this.payee_id != undefined){
            this.setPayeeOnForm();
           }

         }, error => {
         	modal_ref_login.close();
         	this.handleError(error);
         });

  }

  setPayeeOnForm(){
  	this.payeeService.get(this.payee_id).then(payee => {
  		this.payee = payee;
      this.originalPayee = _.cloneDeep(payee);

  	}).catch(error => {
  		this.handleError(error);
  	});
  }

  handleChoosePerson(){
	  let modal_ref_person = this.modal.open(ModalChoosePersonComponent, { size: 'lg'});

	      modal_ref_person.componentInstance.person_selected$.subscribe((selected_person: Person) => {
	       modal_ref_person.close();
	       this.doCopyPersonDetails(selected_person);
	       });

	     modal_ref_person.componentInstance.add_new_selected$.subscribe((is_add_new: boolean) =>{
         if(is_add_new){
           modal_ref_person.close();

           this.addPersonViewService.doAddPerson().then(new_person => {

             this.personService.create(new_person).then(person => {

               this.doCopyPersonDetails(new_person);

             }).catch(error => {
               this.handleError(error);
             });

           }).catch(error => {
             this.handleError(error);
           });
         }
       }, error => {
         this.handleError(error);
       });

	}

	handleSelectExistingPayee(){

		  let modal_ref_payee = this.modal.open(ModalChoosePayeeComponent, {size: 'lg'});

	       modal_ref_payee.componentInstance.payee_selected$.subscribe((selected_payee: Payee) => {
	       modal_ref_payee.close();
	       this.payee = selected_payee;
          this.originalPayee = _.cloneDeep(selected_payee);
   		});

	       modal_ref_payee.componentInstance.add_new_selected$.subscribe(is_add_new => {
	       		this.handleReset();
	       });
	}

  private doCopyPersonDetails(person: Person){
    //reset each time
    this.has_usef_contact_override = false;
      this.payee.address_1 = '';
      this.payee.address_2 = '';
      this.payee.phone = '';
      this.payee.email = '';

    if(person.use_usef_personal_details){
      this.has_usef_contact_override = true;
    } else {
      this.payee.address_1 = person.address_1;
      this.payee.address_2 = person.address_2;
      this.payee.phone = person.phone;
      this.payee.email = person.email;
    }

    this.payee.name = person.first_name + " " + person.last_name;
    this.payee.city = person.city;
    this.payee.state = person.state;
    this.payee.zip = person.postal_code;
    this.payee.country = person.country;

  }

  handleAddPerson(){
  	    //COpy from fields
    let peep = new Person({
        id: null,
        first_name: '',
        last_name: '',
        address_1: this.payee.address_1,
        address_2: this.payee.address_2,
        city: this.payee.city,
        state: this.payee.state,
        postal_code: this.payee.zip,
        country: this.payee.country,
        phone: this.payee.phone,
        email: this.payee.email});

      let modal_ref_person = this.modal.open(ModalAddPersonComponent, { size: 'lg'});

      modal_ref_person.componentInstance.person = peep;

      modal_ref_person.componentInstance.person_saved$.subscribe((new_person: Person) => {
        modal_ref_person.close();

        //save the peep
        this.personService.create(new_person).then(new_person => {
          this.signer_person = new_person;
        }).catch(error => {
          this.handleError(error);
        });


       }, error => {
         this.handleError(error);
       });
  }

  handleChangeSignerPerson(){
	let modal_ref_person = this.modal.open(ModalChoosePersonComponent, { size: 'lg'});

  modal_ref_person.componentInstance.setAllowAddNew(false);

      modal_ref_person.componentInstance.person_selected$.subscribe((selected_person: Person) => {
       modal_ref_person.close();
       this.signer_person = selected_person;
       });

      modal_ref_person.componentInstance.add_new_selected$.subscribe((is_add_new: boolean) =>{
         if(is_add_new){
           modal_ref_person.close();

           this.addPersonViewService.doAddPerson().then(new_person => {

             this.personService.create(new_person).then(person => {

               this.signer_person = new_person;

             }).catch(error => {
               this.handleError(error);
             });

           }).catch(error => {
             this.handleError(error);
           });
         }
       }, error => {
         this.handleError(error);
       });
  }


  handleReset(){
    this.payee = new Payee({});
    this.originalPayee = new Payee({});
    this.initBlankSignature();
    this.getDefaultUserPerson();
    alert("Form reset to empty.");
  }

  handleSave(){
  	//Check requirements / validate
  		let errors:string[] = [];
  		if(this.payee.name == undefined || this.payee.name.length < 1){
			errors.push("Name is a required field! Cannot save a payee without a name");
		}

		if(this.payee.city == undefined || this.payee.city.length <1){
			errors.push("City is a required field! Cannot save a payee without a city");
		}

		if(this.payee.state == undefined || this.payee.state.length <1){
			errors.push("State is a required field! Cannot save a payee without a state");
		}

		if(this.payee.address_1 == undefined || this.payee.address_1.length < 1){
			errors.push("Address 1 is a required field! Cannot save a payee without an Address 1");
		}

		if(this.payee.zip == undefined || this.payee.zip.length < 1){
			errors.push("Zip or postal code is a required field! Cannot save a payee without a zip or postal code");
		}

		//Parameters required for US Citizen / Resident
		if(!this.payee.non_resident){
			if((this.payee.ssn == undefined || this.payee.ssn.length < 1) && (this.payee.ein == undefined || this.payee.ein.length < 1)) {
				errors.push("A payee domiciled in the United States must provide either an SSN or an EIN.");
			}
		}

    //Check signature - email requests are disabled on this form, so the signer must sign here
    if(!this.signer_person?.id || !this.signature?.signature?.trim() || !this.signature.accepted_terms || !this.signature.read_document){
      errors.push("This document must be electronically signed and the signer must indicate that they have read and accepted the terms of the document.");
    }

		if(errors.length > 0){
			this.handleError(errors.join("\n"));
			return;
		}

    if(this.submitted){
      return;
    }
    this.submitted = true;

    //Unchanged payees are reused; changed ones are saved as a new W9 so other entries keep theirs
    this.payeeService.saveForEntry(this.payee, this.originalPayee).then(saved_payee => {
      //Re-baseline so a retry after a later failure reuses this payee instead of creating another
      this.payee = saved_payee;
      this.originalPayee = _.cloneDeep(saved_payee);
      this.doNextStepAndSaveSignature(saved_payee);
    }).catch(error => {
      this.submitted = false;
      this.handleError(error);
    });

  }

  private doNextStepAndSaveSignature(payee: Payee){

    this.signature.user_person_id = this.signer_person.id;

		this.signature.role = "PAYEE";
  		this.signature.document_type = 'HORSE SHOW ENTRY';
  		this.signature.document_id = this.entry_id;

  	if(this.signature.id != undefined && this.signature.id.length > 0){
  		//update

  		this.signatureService.update_signature(this.signature).then(upd_signature => {
  			this.doFinalStepAndUpdateHorse_show_entry(payee);
  		}).catch(error => {
  			this.submitted = false;
  			this.handleError(error);
  		});
  	} else {
  		//create
  		this.signatureService.create(this.signature).then(signature => {
  			this.doFinalStepAndUpdateHorse_show_entry(payee);
  		}).catch(error => {
  			this.submitted = false;
  			this.handleError(error);
  		});
  	}
  }


  private doFinalStepAndUpdateHorse_show_entry(payee: Payee) {

  	this.horseShowEntryService.updatePayeeOnEntry(this.horse_show_entry.id, payee.id).then(response => {
  		if(response == true){
  			this.moveOtherEntries(payee);
  		} else {
  			this.submitted = false;
  			this.handleError("The W9 was saved but could not be attached to this entry. Please try again or contact the horse show office.");
  		}
  	}).catch(error =>{
  		this.submitted = false;
  		this.handleError(error);
  	})

  }

  //A corrected W9 (a new payee) goes to the other entries the user ticked, under the same signature
  private moveOtherEntries(payee: Payee) {
    if(!this.payee_id || payee.id == this.payee_id || this.other_entry_ids.length == 0){
      this.handleFinish();
      return;
    }

    const signature = _.cloneDeep(this.signature);
    delete signature.id;
    delete signature.document_id;

    this.payeeService.moveEntriesToPayee(this.payee_id, payee.id, this.other_entry_ids, signature).then(results => {
      const not_moved = results.filter(result => !result.moved);
      if(not_moved.length == 0){
        this.handleFinish();
        return;
      }
      this.moves_incomplete = true;
      this.handleError("This entry now uses the corrected W9, but these entries were not changed:\n"
        + not_moved.map(result => (result.entry_number ? '#' + result.entry_number : result.entry_id) + ': ' + result.reason).join("\n"));
    }).catch(error => {
      this.moves_incomplete = true;
      this.handleError("This entry now uses the corrected W9, but your other entries could not be updated. They still use the W9 they had. "
        + (typeof error === 'string' ? error : ''));
    });
  }

  handleFinish() {
    this.saved$.emit(true);
    this.router.navigate(['edit-payee-for-horse-show-entry/edit-payee-complete']);
  }

 private getDefaultUserPerson() {
    this.smsApiSessionService.getSession().then((user: User) => {

          this.personService.get(user.user_person_id).then(person => {
            this.signer_person = person;
            this.signature.user_person_id = person.id;
          }).catch(error => {
            this.handleError(error);
          });
        }).catch(error => {
          this.handleError(error);
        });
  }

 handlePayeeSignature(signature: Signature){
    signature.party_to_entry = 'PAYEE';
    this.signature = signature;
  }

  private initBlankSignature() {
    this.signature = new Signature({
       document_id: this.entry_id,
       document_type: "HORSE SHOW ENTRY",
       read_document: false,
       signature: '',
       user_person_id: this.signer_person.id,
       role: 'PAYEE',
       accepted_terms: false,
       responsible_party: false,
          contact_consent: false
        });
  }


}
